import { displayStringFromFHIRCodeableConcept, simpleDisplayStringFromFHIRCodeableConcept } from "../../datatypeComponents/CodeableConceptEntry";
import { displayStringFromFHIRIdentifier } from "../../datatypeComponents/IdentifierEntry";
import { displayStringFromFHIRPeriod, getDateDisplay } from "../../datatypeComponents/PeriodEntry";
import { displayStringFromFHIRQuantity } from "../../datatypeComponents/QuantityEntry";
import { displayStringFromFHIRReference } from "../../datatypeComponents/ReferenceEntry";

const generateNarrativeForResearchStudyResource = (resource) => {
    let status = "generated";
    let innerDiv = "";
    try {
        if (resource.title) {
            innerDiv += "<p><b>Title: </b>" + resource.title + "</p>";
        }
        if (resource.name) {
            innerDiv += "<p><b>Name: </b>" + resource.name + "</p>";
        }
        if (resource.label?.length > 0) {
            innerDiv += resource.label.map((item) => {
                let type = displayStringFromFHIRCodeableConcept(item.type) || "Label";
                let value = item.value || "";
                return "<p><b>" + type + ": </b>" + value + "</p>"
            }).join("");
        }
        if (resource.identifier?.length > 0) {
            innerDiv += resource.identifier.map((item) => {
                return "<p><b>Identifier: </b>" + displayStringFromFHIRIdentifier(item) + "</p>"
            }).join("");
        }
        if (resource.version) {
            innerDiv += "<p><b>Version: </b>" + resource.version + "</p>";
        }
        if (resource.partOf?.length > 0) {
            innerDiv += resource.partOf.map((item) => {
                return "<p><b>Part of: </b>" + displayStringFromFHIRReference(item) + "</p>"
            }).join("");
        }
        if (resource.period) {
            innerDiv += "<p><b>Study start and end: </b>" + displayStringFromFHIRPeriod(resource.period) + "</p>";
        }
        if (resource.progressStatus?.length > 0) {
            innerDiv += resource.progressStatus.map((item) => {
                let state = displayStringFromFHIRCodeableConcept(item.state) || "";
                let actual = "";
                if (item.actual === true) {
                    actual = "Actual";
                }
                if (item.actual === false) {
                    actual = "Anticipated";
                }
                let period = displayStringFromFHIRPeriod(item.period) || "";
                return "<p><b>Progress Status: </b>" + state + "(" + period + " " + actual + ")</p>"
            }).join("");
        }
        if (resource.whyStopped) {
            innerDiv += "<p><b>Why stopped: </b>" + displayStringFromFHIRCodeableConcept(resource.whyStopped) + "</p>";
        }
        if (resource.descriptionSummary) {
            innerDiv += "<p><b>Brief Description: </b>" + resource.descriptionSummary + "</p>";
        }
        if (resource.description) {
            innerDiv += "<p><b>Description: </b>" + resource.description + "</p>";
        }
        if (resource.primaryPurposeType) {
            innerDiv += "<p><b>Purpose Type: </b>" + displayStringFromFHIRCodeableConcept(resource.primaryPurposeType) + "</p>";
        }
        if (resource.focus?.concept) {
            innerDiv += "<p><b>Focus: </b>" + displayStringFromFHIRCodeableConcept(resource.focus.concept) + "</p>";
        }
        if (resource.focus?.reference) {
            innerDiv += "<p><b>Focus: </b>" + displayStringFromFHIRReference(resource.focus.reference) + "</p>";
        }
        if (resource.condition?.length > 0) {
            innerDiv += resource.condition.map((item) => {
                return "<p><b>Condition: </b>" + displayStringFromFHIRCodeableConcept(item) + "</p>"
            }).join("");
        }
        if (resource.keyword?.length > 0) {
            innerDiv += resource.keyword.map((item) => {
                return "<p><b>Keyword: </b>" + displayStringFromFHIRCodeableConcept(item) + "</p>"
            }).join("");
        }
        if (resource.classifier?.length > 0) {
            innerDiv += resource.classifier.map((item) => {
                return "<p><b>Classifier: </b>" + displayStringFromFHIRCodeableConcept(item) + "</p>"
            }).join("");
        }
        if (resource.region?.length > 0) {
            innerDiv += resource.region.map((item) => {
                return "<p><b>Region: </b>" + displayStringFromFHIRCodeableConcept(item) + "</p>"
            }).join("");
        }
        if (resource.phase) {
            innerDiv += "<p><b>Phase: </b>" + displayStringFromFHIRCodeableConcept(resource.phase) + "</p>";
        }
        if (resource.studyDesign?.length > 0) {
            innerDiv += resource.studyDesign.map((item) => {
                return "<p><b>Study Design: </b>" + displayStringFromFHIRCodeableConcept(item) + "</p>"
            }).join("");
        }
        if (resource.extension?.length > 0) {
            let extensions = resource.extension || [];
            if (extensions?.length > 0) {
                for (const extension of extensions) {
                    if (extension.url === "http://hl7.org/fhir/uv/ebm/StructureDefinition/research-study-search-strategy") {
                        let searchStrategy = displayStringFromFHIRReference(extension.valueReference);
                        innerDiv += "<p><b>Search Strategy:</b> " + searchStrategy + "</p>";
                    }
                    if (extension.url === "http://hl7.org/fhir/uv/ebm/StructureDefinition/research-study-systematic-review-eligibility-criteria") {
                        let reviewEligCrit = displayStringFromFHIRReference(extension.valueReference);
                        innerDiv += "<p><b>Systematic Review Eligibility Criteria:</b> " + reviewEligCrit + "</p>";
                    }
                    if (extension.url === "http://hl7.org/fhir/uv/ebm/StructureDefinition/research-study-sponsor-confidentiality-statement") {
                        let confidentialityStatement = extension.valueString;
                        innerDiv += "<p><b>Sponsor Confidentiality Statement:</b> " + confidentialityStatement + "</p>";
                    }
                    if (extension.url === "http://hl7.org/fhir/uv/ebm/StructureDefinition/research-study-sae-reporting-method") {
                        let saeReportingMethod = extension.valueString;
                        innerDiv += "<p><b>Serious Adverse Event Reporting Method:</b> " + saeReportingMethod + "</p>";
                    }
                    if (extension.url === "http://hl7.org/fhir/uv/ebm/StructureDefinition/research-study-study-amendment" && extension.extension?.length) {
                        innerDiv += "<h4>Study Amendment</h4>"
                        for (const ext of extension.extension) {
                            if (ext.url === "details" && ext.valueString) {
                                innerDiv += "<p><b>Details:</b> " + ext.valueString + "</p>";
                            } else if (ext.url === "scope" && ext.valueString) {
                                innerDiv += "<p><b>Scope:</b> " + ext.valueString + "</p>";
                            } else if (ext.url === "description" && ext.valueString) {
                                innerDiv += "<p><b>Description:</b> " + ext.valueString + "</p>";
                            } else if (ext.url === "rationale" && ext.valueString) {
                                innerDiv += "<p><b>Rationale:</b> " + ext.valueString + "</p>";
                            } else if (ext.url === "substantialImpactSafety" && ext.valueBoolean === true) {
                                innerDiv += "<p><b>Substantial Impact on Safety:</b> YES</p>";
                            } else if (ext.url === "substantialImpactSafety" && ext.valueBoolean === false) {
                                innerDiv += "<p><b>Substantial Impact on Safety:</b> No</p>";
                            } else if (ext.url === "substantialImpactSafetyComment" && ext.valueString) {
                                innerDiv += "<p><b>Substantial Impact on Safety Comment:</b> " + ext.valueString + "</p>";
                            } else if (ext.url === "substantialImpactReliability" && ext.valueBoolean === true) {
                                innerDiv += "<p><b>Substantial Impact on Reliability:</b> YES</p>";
                            } else if (ext.url === "substantialImpactsubstantialImpactReliabilitySafety" && ext.valueBoolean === false) {
                                innerDiv += "<p><b>Substantial Impact on Reliability:</b> No</p>";
                            } else if (ext.url === "substantialImpactReliabilityComment" && ext.valueString) {
                                innerDiv += "<p><b>Substantial Impact on Reliability Comment:</b> " + ext.valueString + "</p>";
                            } else if (ext.url === "primaryReason" && ext.valueCodeableConcept) {
                                innerDiv += "<p><b>Primary Reason:</b> " + displayStringFromFHIRCodeableConcept(ext.valueCodeableConcept) + "</p>";
                            }
                        }
                    }
                    if (extension.url === "http://hl7.org/fhir/uv/pharmaceutical-research-protocol/StructureDefinition/protocol-amendment") {
                        innerDiv += "<h4>Study Amendment</h4>"
                        for (const ext of extension.extension) {
                            if (ext.url === "http://hl7.org/fhir/uv/pharmaceutical-research-protocol/StructureDefinition/protocol-amendment-detail" &&
                                ext.extension?.length) {
                                innerDiv += "<p><b>Section Detail:</b></p>";
                                for (const extens of ext.extension) {
                                    if (extens.url === "detail" && extens.valueString) {
                                        innerDiv += "<p>...Detail: " + extens.valueString + "</p>";
                                    } else if (extens.url === "rationale" && extens.valueString) {
                                        innerDiv += "<p>...Rationale: " + extens.valueString + "</p>";
                                    } else if (extens.url === "section" && extens.valueCodeableConcept) {
                                        innerDiv += "<p>...Section: " + displayStringFromFHIRCodeableConcept(extens.valueCodeableConcept) + "</p>";
                                    }
                                }
                                innerDiv += "<br/>";
                            } else if (ext.url === "scope" && ext.valueCode) {
                                innerDiv += "<p><b>Scope:</b> " + ext.valueCode + "</p>";
                            } else if (ext.url === "country" && ext.valueCode) {
                                innerDiv += "<p><b>Country:</b> " + ext.valueCode + "</p>";
                            } else if (ext.url === "region" && ext.valueCode) {
                                innerDiv += "<p><b>Region:</b> " + ext.valueCode + "</p>";
                            } else if (ext.url === "site" && ext.valueIdentifier) {
                                innerDiv += "<p><b>Site:</b> " + displayStringFromFHIRIdentifier(ext.valueIdentifier) + "</p>";
                            } else if (ext.url === "approvalDate" && ext.valueDate) {
                                innerDiv += "<p><b>Approval date:</b> " + getDateDisplay(ext.valueDate) + "</p>";
                            } else if (ext.url === "signature" && ext.valueSignature) {
                                innerDiv += "<p><b>Signature:</b> Signed</p>";
                            } else if (ext.url === "signatureURL" && ext.valueString) {
                                innerDiv += "<p><b>Signature URL:</b> " + ext.valueString + "</p>";
                            } else if (ext.url === "signatureMethod" && ext.valueString) {
                                innerDiv += "<p><b>Signature method:</b> " + ext.valueString + "</p>";
                            } else if (ext.url === "http://hl7.org/fhir/uv/pharmaceutical-research-protocol/StructureDefinition/ResearchStudyStudyAmendmentScopeImpact" &&
                                ext.extension?.length) {
                                for (const extens of ext.extension) {
                                    if (extens.url === "number" && extens.valuePositiveInt) {
                                        innerDiv += "<p><b>Scope impact:</b> " + ext.valuePositiveInt.toString() + " participants</p>";
                                    } else if (extens.url === "number" && extens.valueQuantity) {
                                        innerDiv += "<p><b>Scope impact:</b> " + displayStringFromFHIRQuantity(ext.valueQuantity) + " percentage of participants</p>";
                                    } else if (extens.url === "scope" && extens.valueCode) {
                                        innerDiv += "<p><b>Scope impact:</b> " + extens.valueCode + "</p>";
                                    }
                                }
                            } else if (ext.url === "description" && ext.valueString) {
                                innerDiv += "<p><b>Description:</b> " + ext.valueString + "</p>";
                            } else if (ext.url === "rationale" && ext.valueString) {
                                innerDiv += "<p><b>Rationale:</b> " + ext.valueString + "</p>";
                            } else if (ext.url === "summary" && ext.valueString) {
                                innerDiv += "<p><b>Summary:</b> " + ext.valueString + "</p>";
                            } else if (ext.url === "substantialImpactSafety" && ext.valueCode) {
                                innerDiv += "<p><b>Substantial Impact on Safety:</b> " + ext.valueCode + "</p>";
                            } else if (ext.url === "substantialImpactSafetyComment" && ext.valueString) {
                                innerDiv += "<p><b>Substantial Impact on Safety Comment:</b> " + ext.valueString + "</p>";
                            } else if (ext.url === "substantialImpactReliability" && ext.valueCode) {
                                innerDiv += "<p><b>Substantial Impact on Reliability:</b> " + ext.valueCode + "</p>";
                            } else if (ext.url === "substantialImpactReliabilityComment" && ext.valueString) {
                                innerDiv += "<p><b>Substantial Impact on Reliability Comment:</b> " + ext.valueString + "</p>";
                            } else if (ext.url === "primaryReason" && ext.valueCodeableConcept) {
                                innerDiv += "<p><b>Primary Reason:</b> " + displayStringFromFHIRCodeableConcept(ext.valueCodeableConcept) + "</p>";
                            } else if (ext.url === "secondaryReason" && ext.valueCodeableConcept) {
                                innerDiv += "<p><b>Secondary Reason:</b> " + displayStringFromFHIRCodeableConcept(ext.valueCodeableConcept) + "</p>";
                            }
                        }
                    }
                    if (extension.url === "http://hl7.org/fhir/uv/pharmaceutical-research-protocol/StructureDefinition/narrative-elements") {
                        let narrativeReference = extension.valueReference;
                        innerDiv += "<p><b>Narrative reference:</b> " + displayStringFromFHIRReference(narrativeReference) + "</p><br />";
                    }
                }
            }
        }
        if (resource.protocol?.length > 0) {
            innerDiv += resource.protocol.map((item) => {
                return "<p><b>Protocol: </b>" + displayStringFromFHIRReference(item) + "</p>"
            }).join("");
        }
        if (resource.relatedArtifact?.length > 0) {
            innerDiv += resource.relatedArtifact.map((item) => {
                let type = "";
                if (item.type?.coding || item.type?.text) {
                    type = simpleDisplayStringFromFHIRCodeableConcept(item.type);
                } else if (item.type) {
                    type = item.type;
                }
                let display = item.display || "";
                let citation = item.citation || "";
                let resource = item.resource || "";
                let resourceReference = displayStringFromFHIRReference(item.resourceReference) || "";
                return "<p><b>Related Item (" + type + "): </b>" + display + " " + citation + " " + resource + " " + resourceReference + "</p>"
            }).join("");
        }
        if (resource.relatesTo?.length > 0) {
            innerDiv += resource.relatesTo.map((item) => {
                let type = "";
                if (item.type?.coding || item.type?.text) {
                    type = simpleDisplayStringFromFHIRCodeableConcept(item.type);
                } else if (item.type) {
                    type = item.type;
                }
                let string = item.targetMarkdown || item.targetUri || item.targetCanonical || "";
                let resourceReference = displayStringFromFHIRReference(item.targetReference) || "";
                return "<p><b>Related Item (" + type + "): </b>" + string + resourceReference + "</p>"
            }).join("");
        }
        if (resource.note?.length > 0) {
            innerDiv += resource.note.map((note) => {
                return "<p><b>Note: </b>" + note.text + "</p>"
            }).join("");
        }
        if (resource.associatedParty?.length > 0) {
            innerDiv += resource.associatedParty.map((item) => {
                let name = item.name || "";
                let role = displayStringFromFHIRCodeableConcept(item.role) || "";
                let party = displayStringFromFHIRReference(item.party) || "";
                return "<p><b>Associated Party: </b>" + name + " (" + role + ") " + party + "</p>"
            }).join("");
        }
        if (resource.site?.length > 0) {
            innerDiv += resource.site.map((item) => {
                return "<p><b>Site: </b>" + displayStringFromFHIRReference(item) + "</p>"
            }).join("");
        }
        if (resource.recruitment?.targetNumber) {
            innerDiv += "<p><b>Target number of participants: </b>" + resource.recruitment.targetNumber + "</p>";
        }
        if (resource.recruitment?.actualNumber) {
            innerDiv += "<p><b>Actual number of participants: </b>" + resource.recruitment.actualNumber + "</p>";
        }
        if (resource.recruitment?.eligibility) {
            innerDiv += "<p><b>Eligibility Criteria: </b>" + displayStringFromFHIRReference(resource.recruitment.eligibility) + "</p>";
        }
        if (resource.recruitment?.actualGroup) {
            innerDiv += "<p><b>Enrollment Group: </b>" + displayStringFromFHIRReference(resource.recruitment.actualGroup) + "</p>";
        }
        if (resource.comparisonGroup?.length > 0) {
            innerDiv += "<p><b>Comparison Groups</b></p><table><tr><th>Target number</th><th>Actual number</th><th>Eligibility Criteria</th><th>Observed Group</th></tr>"
            innerDiv += resource.comparisonGroup.map((item, itemIndex) => {
                let targetNumber = "";
                if (item.targetNumber || item.targetNumber === 0) {
                    targetNumber = item.targetNumber;
                }
                let actualNumber = "";
                if (item.actualNumber || item.actualNumber === 0) {
                    actualNumber = item.actualNumber;
                }
                let eligibility = "";
                if (item.eligibility) {
                    eligibility = displayStringFromFHIRReference(item.eligibility);
                }
                let observedGroup = "";
                if (item.observedGroup) {
                    observedGroup = displayStringFromFHIRReference(item.observedGroup);
                }
                return "<tr><td>" +
                    targetNumber + "</td><td>" +
                    actualNumber + "</td><td>" +
                    eligibility + "</td><td>" +
                    observedGroup + "</td></tr>";
            }).join("");
            innerDiv += "</table>";
        }
        if (resource.objective?.length > 0) {
            innerDiv += resource.objective.map((item, itemIndex) => {
                let name = item.name || "";
                let type = item.type?.coding?.[0]?.display || item.type?.coding?.[0]?.code || item.type?.text || "";
                let description = item.description || "";
                let objectiveDisplay = "<p><b>Objective " + (itemIndex + 1).toString() + ": </b>" + name;
                if (type) {
                    objectiveDisplay += " (" + type + " objective)";
                }
                objectiveDisplay += "</p>";
                if (description) {
                    objectiveDisplay += "<p>Description: " + description + "</p>";
                }
                if (item.outcomeMeasure) {
                    objectiveDisplay += "<p><b>Outcome Measures:</b></p><table><tr><th>Name (type)</th><th>Description</th><th>Endpoint</th><th>Summary Measure</th><th>Event Handling</th></tr>";
                    objectiveDisplay += item.outcomeMeasure.map((om) => {
                        let omName = om.name || "";
                        let omType = displayStringFromFHIRCodeableConcept(om.type) || "";
                        let omDescription = om.description || "";
                        let omEndpoint = displayStringFromFHIRReference(om.endpoint) || "";
                        let omPopulation = displayStringFromFHIRReference(om.population) || "";
                        let omIntervention = displayStringFromFHIRReference(om.intervention) || "";
                        let omComparator = displayStringFromFHIRReference(om.comparator) || "";
                        let omSummaryMeasure = displayStringFromFHIRCodeableConcept(om.summaryMeasure) || "";
                        let outcomeMeasureDisplay = "<tr><td>" + omName;
                        if (omType) {
                            outcomeMeasureDisplay += " (" + omType + " outcome)";
                        }
                        outcomeMeasureDisplay += "</td><td>" + omDescription + "</td><td>" + omEndpoint + "</td><td>";
                        if (omPopulation) {
                            outcomeMeasureDisplay += "<p>Population: " + omPopulation + "</p>";
                        }
                        if (omIntervention) {
                            outcomeMeasureDisplay += "<p>Intervention Group: " + omIntervention + "</p>";
                        }
                        if (omComparator) {
                            outcomeMeasureDisplay += "<p>Comparator Group: " + omComparator + "</p>";
                        }
                        if (omSummaryMeasure) {
                            outcomeMeasureDisplay += "<p>Summary Measure: " + omSummaryMeasure + "</p>";
                        }
                        outcomeMeasureDisplay += "</td><td>";
                        if (om.eventHandling) {
                            outcomeMeasureDisplay += om.eventHandling.map((eh) => {
                                let event = displayStringFromFHIRCodeableConcept(eh.event) || "";
                                let group = displayStringFromFHIRCodeableConcept(eh.group) || "";
                                let handling = displayStringFromFHIRCodeableConcept(eh.handling) || "";
                                let ehDescription = eh.description || "";
                                let eventHandlingDisplay = "<p>";
                                if (event || group || handling) {
                                    eventHandlingDisplay += event + " (" + group + "): " + handling;
                                }
                                if (ehDescription) {
                                    if (eventHandlingDisplay !== "<p>") {
                                        eventHandlingDisplay += "; ";
                                    }
                                    eventHandlingDisplay += ehDescription;
                                }
                                eventHandlingDisplay += "</p>";
                                return eventHandlingDisplay;
                            }).join("");
                        }
                        outcomeMeasureDisplay += "</td></tr>";
                        return outcomeMeasureDisplay;
                    }).join("");
                    objectiveDisplay += "</table>";
                }
                return objectiveDisplay
            }).join("");
        }
        if (resource.outcomeMeasure?.length > 0) {
            innerDiv += resource.outcomeMeasure.map((item) => {
                let name = item.name || "";
                let type = "";
                if (item.type?.length) {
                    type = displayStringFromFHIRCodeableConcept(item.type[0]) || "";
                }
                let description = item.description || "";
                let reference = displayStringFromFHIRReference(item.reference) || "";
                return "<p><b>Objective: </b>" + name + " (" + type + ") " + description + " " + reference + "</p>"
            }).join("");
        }
        if (resource.extension?.length > 0) {
            let extensions = resource.extension || [];
            if (extensions?.length > 0) {
                for (const extension of extensions) {
                    if (extension.url === "http://hl7.org/fhir/uv/ebm/StructureDefinition/research-study-number-of-studies-identified") {
                        innerDiv += "<p><b>Number of studies identified:</b> " + extension.valueUnsignedInt + "</p>";
                    }
                    if (extension.url === "http://hl7.org/fhir/uv/ebm/StructureDefinition/research-study-number-of-studies-included") {
                        innerDiv += "<p><b>Number of studies included:</b> " + extension.valueUnsignedInt + "</p>";
                    }
                }
            }
        }
        if (Array.isArray(resource.result) && resource.result.length > 0) {
            innerDiv += resource.result.map((item) => {
                return "<p><b>Result: </b>" + displayStringFromFHIRReference(item) + "</p>"
            }).join("");
        }
    } catch {
        innerDiv = "[Unable to generate Narrative Summary.]"
    }
    return { "status": status, "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">" + innerDiv + "</div>" };
}

export default generateNarrativeForResearchStudyResource;